<template>
	<div class="d-flex flex-column flex h100">
		<div class="navbar theme-login bg box-shadow">
			<div>
				<a href="#/" class="navbar-brand oscar-logo">
					<img :src="brand.logoHeader" alt="." class />
				</a>
			</div>
		</div>
		<div id="content-body">
			<div class="banner"></div>
			<div class="py-2 text-center w-100">
				<div class="mx-auto col-6 w-auto-xs" style="min-width: 320px;">
					<div class="px-6 mt-3">
						<div class="box page-shadow">
							<div class="box-body p-5">
								<img
									style="max-width:90%; opacity: 0.7; max-height: 300px;"
									class="logo ng-scope pb-3"
									:src="brand.logo"
								/>
								<hr />
								<form @submit.prevent name="emailForm" v-if="!this.token">
									<h3>Reset Password</h3>

									<p>We'll email you instructions on how to reset your password</p>
									<div class="form-group">
										<input
											v-model="email"
											type="email"
											class="form-control form-control-lg"
											placeholder="Email"
											required
										/>
									</div>

									<button @click="reset()" type="submit" class="btn btn-block btn-lg theme-login">
										Reset Password
									</button>
								</form>
								<form @submit.prevent name="resetForm" v-if="this.token">
									<h3>Reset Password</h3>

									<p>Please enter a new password</p>
									<div class="form-group" :class="{ invalid: !valid.field('password') }">
										<label>New Password</label>
										<input
											type="password"
											class="form-control form-control-lg"
											v-model="password"
										/>
									</div>
									<div class="form-group" :class="{ invalid: !valid.field('passwordMatch') }">
										<label>Confirm Password</label>
										<input
											type="password"
											class="form-control form-control-lg"
											v-model="password2"
										/>
									</div>

									<button
										@click="newPW()"
										type="submit"
										class="btn btn-block btn-lg theme-login mb-2"
										:disabled="!valid.group('reset')"
									>
										Reset Password
									</button>

									<div
										class="mt-1 mb-0 text-xs text-muted"
										v-for="error in valid.errors()"
										:key="error"
									>
										{{ error }}
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-3 b-t mt-auto theme-login">© 2021 Copyright MZ Development v{{ version }}</div>
	</div>
</template>

<script>
import AuthService from "@/services/AuthService";
import ValidationService from "@/services/ValidationService";
import notie from "@/services/NotieService";
import Router from "@/router";
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();
import pack from "../../../package.json";

export default {
	name: "ResetPW",

	props: ["query"],

	data() {
		return {
			brand: brand,
			version: pack.version,
			token: null,
			email: null,
			password: null,
			password2: null,

			valid: {}
		};
	},
	created() {
		this.token = this.$route.query.token;
		AuthService.clearState();
		this.initValidation();
	},
	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				anyPassword: {
					group: "reset",
					errorMsg: "You must provide a new password",
					func: () => {
						return this.password;
					}
				},
				password: {
					group: "reset",
					errorMsg: "Your password must be at least 5 characters long",
					func: () => {
						return !this.password || this.password.length >= 5;
					}
				},
				passwordMatch: {
					group: "reset",
					errorMsg: "Your passwords must match",
					func: () => {
						return !this.password || this.password == this.password2;
					}
				}
			});
		},

		reset() {
			var _this = this;
			AuthService.resetPassword(this.email)
				.then(resp => {
					notie.success("Reset email sent");
					this.$router.push("/");
				})
				.catch(err => {
					console.log(err);
					notie.error("Invalid email to reset", err);
				});
		},

		newPW() {
			AuthService.setNewPassword(this.token, this.password)
				.then(resp => {
					notie.success("Password reset");
					this.$router.push("/");
				})
				.catch(err => {
					notie.error("Failed to reset password", err);
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/vues/Login/ResetPW.vue